// extracted by mini-css-extract-plugin
export default {"logo":"xMCkvv","hide":"uWeKKr","image":"_r80KS","large":"N8YN3b"};